<template>
  <div class="text-left">
    <div class="grid">
      <div class="col-6">
        <label>Número </label>
        <div class="p-inputgroup pt-1">
          <InputText placeholder="Número de territorio" data-e2e="input-numero-territorio" v-model="numero"/>
        </div>
      </div>
      <div class="col-6">
        <label>Zona (opcional)</label>
        <div class="p-inputgroup pt-1">
          <InputText placeholder="Zona (ej: A, AB, Norte)" v-model="zona" maxlength="10" />
        </div>
      </div>
      <div class="col-6">
        <label>Grupo (opcional)</label>
        <div class="p-inputgroup pt-1">
          <Dropdown v-model="terr.grupo" :options="territorios.grupos" option-label="name" option-value="id" placeholder="Grupo" showClear />
        </div>
      </div>

      
      <div class="col-12">
        <label>Referencia</label>
        <div class="p-inputgroup pt-1">
          <InputText placeholder="Nombre por el que se conoce el lugar" v-model="terr.referencia" />
        </div>
      </div>
      <div class="col-12">
        <label>Notas</label>
        <div class="p-inputgroup pt-1">
          <Textarea v-model="terr.notas" :autoResize="true" rows="2"  />
        </div>
      </div>

      <div class="col-6">
        <label>Tipo</label>
        <div class="p-inputgroup pt-1">
          <Dropdown v-model="terr.tipo" :options="tipos" 
          optionLabel="label" optionValue="value"
          placeholder="Tipo" />
        </div>
      </div>
      <div class="col-12 md:col-6">
        <div>
            <label>Color para el territorio</label>
            <div class="w-50 pt-1">
              <ColorPicker v-model="color" />
            </div>
          </div>
      </div>

      <div class="col-12" v-if="terr.tipo === 'routes'">
        <label>Rutas</label>
        <div>
          Para territorios de rutas en lugar de manzanas trabajaras con rutas creadas en la sección de <b>Rutas Rurales</b>
        </div>

      </div>

      

    </div>
  </div>
</template>

<script setup>
import ColorPicker from "primevue/colorpicker";
import { ref, computed } from 'vue'
import { useTerritorioStore } from '@/store/territorio'
import { useTerritoriosStore } from "@/store/territorios";
import { terrColors } from "@/composables/color";
const terr = useTerritorioStore()
const { color } = terrColors(terr);
const territorios = useTerritoriosStore()
const tipos = [
  { label: 'Normal', value: 'default' },
  { label: 'Rutas', value: 'routes' }
]

const numero = computed({
  get() {
    return terr.numero
  },
  set(val) {
    let nro = parseInt(val) || 0

    if (isNaN(nro)) return
    if (nro < 0) return
    // if (nro === 0) nro = ''
    // console.log("setNumber", nro)
    terr.$patch({numero: nro});
  }
})
const zona = computed({
  get() {
    return terr.zona
  },
  set(val) {
    // console.log("setZona", val)
    terr.$patch({zona: val.toUpperCase()});
  }
})
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
  font-weight: lighter;
}
label {
  font-weight: bold;
}
</style>
